import React from "react";
import "./Solar_Power.css";

import { getEffects } from "../../../utils/apis/effects/Effects";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";
import SectionTitle from "../../common/common_title/SectionTitle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import ExploreBtn from "../../common/common-btn/explore_btn/ExploreBtn";
import { useNavigate } from "react-router-dom";

const UltimateEvent = () => {
  const navigate = useNavigate();
  const solarData = [
    {
      title: "Flame Effects",
      span: "  for Homes",
      text:
        "Reduce electricity bills and enjoy reliable, clean energy with easy-to-install residential solar systems.",
      img: "/assets/images/home/solar_power/img-1.png",
    },
    {
      title: "Solar Power for",
      span: "   Housing Societies",
      text:
        "Power common areas efficiently while cutting maintenance costs with scalable solar solutions for societies.",
      img: "/assets/images/home/solar_power/img-2.png",
    },
    {
      title: "Solar Solutions for",
      span: " Commercial & Industrial",
      text:
        "High-performance solar systems designed to lower operational costs and support sustainable business growth.",
      img: "/assets/images/home/solar_power/img-3.png",
    },
  ];

  var HtmlToReactParser = require("html-to-react").Parser;
  var htmlToReactParser = new HtmlToReactParser();

  const [effect, setEffect] = useState([]);

  const { IMG_URL } = useContext(Context);

  const getEffect = async () => {
    const res = await getEffects();
    if (res?.success) {
      setEffect(res.data);
    }
  };
  useEffect(() => {
    getEffect();
  }, []);

  const handleServiceClick = (id) => {
    navigate("/effects", {
      state: { activeTab: id },
    });
  };

  return (
    <section className="Solar_Power">
      <div className="container">
        <div className="section_header_holder">
          <SectionTitle
            title="Ultimate Event Effects"
            subtitle="Ignite Every Show"
          />
        </div>

        <div className="solar_card_div">
          <div className="row justify-content-center">
            {effect.map((item, index) => (
              <div
                className="col-lg-4 col-md-6 col-sm-6 col-12 mb-2 mt-3"
                key={index}
                // onClick={() => {
                //   navigate("/effects");
                // }}
                onClick={() => handleServiceClick(item.id)}
              >
                <div className="solar_box">
                  <div className="solar_img_div">
                    <img
                      src={IDS?.IMG_URL + item?.image}
                      alt={item?.name}
                      className="solar_img"
                    />
                  </div>
                  <div className="solar_content">
                    <div>
                      <h5 className="card_title">{item?.name}</h5>
                      {/* <p className="card_span">{item.subtitle}</p> */}
                      <p className="card_text">
                        {htmlToReactParser.parse(item?.sub_title)}
                      </p>
                    </div>
                    <div className="red-btn">
                      <div className="arrow-btn">
                        <FontAwesomeIcon icon={faAngleRight} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="wrapper-div">
          <ExploreBtn
            text="Explore All"
            onClick={() => {
              navigate("/effects");
            }}
          />
        </div>
      </div>
    </section>
  );
};

export default UltimateEvent;
